import './style/content.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useContact } from '../context/ContactContext';

// Fallback data jika Supabase kosong/error
const FALLBACK = {
  beauty: [
    '/assets/edc (1).png',
    '/assets/edc (2).png',
    '/assets/edc (3).png',
    '/assets/edc (4).png',
    '/assets/edc (5).png',
    '/assets/edc (6).png',
    '/assets/edc (23).png',
    '/assets/edc (24).png',
  ],
  fashion: [
    '/assets/edc (9).png',
    '/assets/edc (10).png',
    '/assets/edc (11).png',
    '/assets/edc (12).png',
    '/assets/edc (13).png',
    '/assets/edc (14).png',
    '/assets/edc (15).png',
    '/assets/edc (16).png',
  ],
  commercial: [
    { type: 'video', src: '/assets/v1.mp4' },
    { type: 'video', src: '/assets/v2.mp4' },
    { type: 'video', src: '/assets/v3.mp4' },
  ],
};

function Portofolio() {
  const [activeTab, setActiveTab] = useState('beauty');
  const [items, setItems] = useState(null);
  const { gdrive_portfolio } = useContact();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const fetchPortfolio = async () => {
      try {
        const { data, error } = await supabase
          .from('portfolio')
          .select('*')
          .order('display_order', { ascending: true })
          .order('created_at', { ascending: true });

        if (error) throw error;

        const grouped = {
          beauty: (data || []).filter((i) => i.category === 'beauty').map((i) => (i.type === 'video' ? { type: 'video', src: i.src } : i.src)),
          fashion: (data || []).filter((i) => i.category === 'fashion').map((i) => (i.type === 'video' ? { type: 'video', src: i.src } : i.src)),
          commercial: (data || []).filter((i) => i.category === 'commercial').map((i) => ({ type: i.type || 'video', src: i.src })),
        };

        const hasData = grouped.beauty.length > 0 || grouped.fashion.length > 0 || grouped.commercial.length > 0;
        setItems(hasData ? grouped : null);
      } catch {
        setItems(null);
      }
    };
    fetchPortfolio();
  }, []);

  const images = items ?? FALLBACK;

  return (
    <section id='portofolio' className='portofolio-section'>
      <div className="container">
        <h1 className="text-center whyus-title" data-aos="fade-up">
          <span style={{ color: '#FFD54F' }}>EDC</span>{" "}
          <span style={{ color: '#1F2937' }}>Portfolio</span>
        </h1>
        <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

        {/* Tab Navigation */}
        <div className="portfolio-tabs" data-aos="fade-up" data-aos-delay="200">
          <button
            className={activeTab === "beauty" ? "active" : ""}
            onClick={() => setActiveTab("beauty")}
          >
            Beauty
          </button>
          <button
            className={activeTab === "fashion" ? "active" : ""}
            onClick={() => setActiveTab("fashion")}
          >
            Fashion
          </button>
          <button
            className={activeTab === "commercial" ? "active" : ""}
            onClick={() => setActiveTab("commercial")}
          >
            Commercial
          </button>
        </div>

        {/* Subtitle */}
        <p className="text-center whyus-subtitle" data-aos="fade-up" data-aos-delay="100">
          {activeTab === "beauty" && "Beauty Commercial Photoshoot"}
          {activeTab === "fashion" && "Fashion Showcase & Runway Looks"}
          {activeTab === "commercial" && "Brand Campaign & Ads"}
          {activeTab === "gdrive" && "Watch our portfolio videos on Google Drive"}
        </p>

        {/* Content */}
        {activeTab === "gdrive" ? (
          <div className="portfolio-gdrive-cta" data-aos="fade-up">
            <a
              href={gdrive_portfolio || 'https://drive.google.com/drive/folders/your-folder-id'}
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-cta-btn"
            >
              <i className="bi bi-google-drive me-2"></i>
              Click here to see EDC Portfolio Videos
              <i className="bi bi-arrow-right ms-2"></i>
            </a>
            <p className="portfolio-cta-desc">Watch our models in action with our video portfolio on Google Drive</p>
          </div>
        ) : (
        <div className="portofolio-grid">
          {activeTab !== 'commercial' ? (
            images[activeTab].map((img, idx) => (
              <div key={idx} className="portofolio-card" data-aos="fade-up" data-aos-delay={idx * 100}>
                <img src={typeof img === 'string' ? img : img?.src} alt={`${activeTab} ${idx + 1}`} />
              </div>
            ))
          ) : (
            images.commercial.map((item, idx) => {
              const isVideo = typeof item === 'object' && item?.type === 'video';
              const src = typeof item === 'object' ? item?.src : item;
              return (
                <div key={idx} className="portofolio-card" data-aos="fade-up" data-aos-delay={idx * 100}>
                  {isVideo ? (
                    <video
                      src={src}
                      controls
                      playsInline
                      preload="metadata"
                      onMouseEnter={(e) => e.target.play()}
                      onMouseLeave={(e) => e.target.pause()}
                    />
                  ) : (
                    <img src={src} alt={`commercial ${idx + 1}`} />
                  )}
                </div>
              );
            })
          )}
        </div>
        )}
      </div>
    </section>
  );
}

export default Portofolio;